module.exports = __webpack_public_path__ + "static/media/coming-soon.e67f0d42.png";